"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkHtmlMulti = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Link = _interopRequireDefault(require("../../components/Link/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Function for link action style
 * @function getLinkHtmlMulti
 * @param { object }  - returns an object with the appropriate HTML markup for link
 */
const getLinkHtmlMulti = data => {
  const {
    action,
    hasOneAction,
    index,
    isKnockoutLink,
    linkStyle
  } = data;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: index
  }, !hasOneAction && /*#__PURE__*/_react.default.createElement("li", {
    className: "pal-c-ActionGroupMulti--listItem",
    key: index
  }, /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    variant: linkStyle.variant,
    isKnockoutLink: isKnockoutLink,
    size: linkStyle.size
  }, action))), hasOneAction && /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    variant: linkStyle.variant,
    isKnockoutLink: isKnockoutLink,
    size: linkStyle.size
  }, action)));
};
exports.getLinkHtmlMulti = getLinkHtmlMulti;